import { Question as modelQuestion } from "../../../models/question";
import i18n from "../../../resources/I18n";
import { Purify } from "../../../util/PurifyTexte";
import "./question.css";
import * as ConstantesAssurabilite from "../../../constants/assurabilite";

export interface IQuestionProps {
  question: modelQuestion;
}

function Question(props: Readonly<IQuestionProps>) {
  const question = props.question;

  const mapperLibellesPuces = question?.libelles?.puces?.map((puce: string, index) => (
    <li key={question.id + puce} dangerouslySetInnerHTML={{ __html: Purify(puce) }} />
  ));
  const nombreElementPuces = question.libelles?.puces?.length;
  const texteNombreElementPuces = i18n
    .t("question-avec-puce-aria-label")
    .replace("{nombrePuces}", String(nombreElementPuces));

  return (
    <>
      <div id="container-question-amc-validation">
        <span slot="legend">
          <span
            data-testid="libelle-question"
            className="libelle-question-amc-validation"
            dangerouslySetInnerHTML={{ __html: question.libelles?.libelle }}
          ></span>
          {nombreElementPuces > 0 && (
            <>
              <span className="elements-puces" aria-label={texteNombreElementPuces} />
              <ul id="liste-puces">{mapperLibellesPuces}</ul>
            </>
          )}
        </span>
      </div>
      <div className="texte-reponse-amc-validation">
        <span>
          {question.reponse === ConstantesAssurabilite.N ? ConstantesAssurabilite.NON : ConstantesAssurabilite.OUI}
        </span>
      </div>
    </>
  );
}

export default Question;
